import { cn } from '~/lib/cn';

export interface FlexColProps
  extends React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >,
    React.PropsWithChildren {
  className?: string;
}

export function FlexCol({ className = '', children, ...rest }: FlexColProps) {
  return (
    <div className={cn('flex flex-col', className)} {...rest}>
      {children}
    </div>
  );
}

FlexCol.displayName = 'FlexCol';
